import { render, staticRenderFns } from "./architecture-v2.vue?vue&type=template&id=1ae9770a&scoped=true"
import script from "./architecture-v2.vue?vue&type=script&lang=js"
export * from "./architecture-v2.vue?vue&type=script&lang=js"
import style0 from "./architecture-v2.vue?vue&type=style&index=0&id=1ae9770a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae9770a",
  null
  
)

export default component.exports